<template>

</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        created() {
            localStorage.setItem('user', null);
            localStorage.removeItem('user');
            this.auth.user = null;

            this.$store.dispatch('auth/logout');

            this.$router.push({name: 'unauthenticated.login'});
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>